import { Memory } from "./types";

export const formatRecordingDuration = (durationSeconds: number) => {
  const totalSeconds = Math.max(0, Math.floor(durationSeconds));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const paddedSeconds = seconds.toString().padStart(2, "0");

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${paddedSeconds}`;
  }

  return `${minutes}:${paddedSeconds}`;
};

export const getRecommendedQuestionPrompts = (
  memories: Memory[],
  fallbackPrompts: string[],
  limit = 3,
) => {
  const prompts = [...memories]
    .filter((memory) => Boolean(memory.id && memory.started_at))
    .sort(
      (a, b) =>
        new Date(b.started_at).getTime() - new Date(a.started_at).getTime(),
    )
    .slice(0, limit)
    .map((memory) =>
      memory.recommended_questions?.find((question) => question.trim())?.trim(),
    )
    .filter((question): question is string => Boolean(question));

  return prompts.length ? prompts : fallbackPrompts.slice(0, limit);
};
